var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { colors, fontWeights } from '../../../defaultTheme';
const CommonStyles = css `
  position: relative;
  font-family: Open Sans;
  font-size: inherit;
  display: ${({ isInline }) => (isInline ? 'inline' : 'flex')};
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  color: ${({ isDisabled, theme }) => isDisabled ? colors.mediumGrey : theme.link};
  overflow: hidden;
  font-weight: ${fontWeights.semiBold};
  height: 24px;
  border: none;
  padding: ${({ isInline }) => (isInline ? '0' : '0 8px')};
  text-decoration: none;

  &:visited {
    color: ${({ isDisabled, theme }) => isDisabled ? colors.mediumGrey : theme.link};
  }

  &:hover {
    text-decoration: ${({ isDisabled }) => (isDisabled ? 'none' : 'underline')};
  }
`;
const IconWrapper = styled.div `
  margin-right: 8px;
`;
/*
 * Filters out the props that <a> doesn't take.
 * This removes 'unrecognized prop' errors.
 */
const Anchor = (_a) => {
    var { isInline, isDisabled, icon, children } = _a, props = __rest(_a, ["isInline", "isDisabled", "icon", "children"]);
    return (React.createElement("a", Object.assign({}, props),
        icon && React.createElement(IconWrapper, null, icon),
        children));
};
export const ExternalRouteLink = styled(Anchor) `
  ${CommonStyles}
`;
/*
 * Filters out the props that <Link> doesn't take.
 * This removes 'unrecognized prop' errors.
 */
const RouterLink = forwardRef((_a, ref) => {
    var { isInline, isDisabled, to, children, icon } = _a, props = __rest(_a, ["isInline", "isDisabled", "to", "children", "icon"]);
    return (React.createElement(Link, Object.assign({ to: to }, props, { ref: ref }),
        icon && React.createElement(IconWrapper, null, icon),
        children));
});
export const InternalRouteLink = styled(RouterLink) `
  ${CommonStyles}
`;
